module.exports = function(polls) {
	"use strict";
  polls
  .controller('allpollsController', allpollsController)
	allpollsController.$inject = ["$filter","watchAllCheckboxesNgTable","$timeout","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","reqursiveService","deleteDataService","alertService","putDataService","serverError","offlineError"];
	
  function allpollsController($filter,watchAllCheckboxesNgTable,$timeout,$stateParams,$state,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,deleteDataService,alertService, putDataService,serverError,offlineError) {
    var vmapl = this;
    var state = 'polls';
    var s;
    var role;
    var date_start;
    var date_end;
    var sortby ='date';
    var $data;
    var page;
    vmapl.status = 'publish';
    var status = 'publish';
    vmapl.selectedTitle = -1;
    vmapl.editPollsShow = false;
    vmapl.selectedRole = {value: 'all'}; 
    vmapl.selectedBulkAction = {value: 'default'};
    vmapl.checkedPostsEdit = [];
    vmapl.checkboxes = { 'checked': false, items: {}};
    vmapl.pollId = $stateParams.id; 
    if($stateParams.id) {
      vmapl.editPollShow = true;
    } else {
      vmapl.editPollShow = false;
    }
    $scope.ranges = {
      'Today': [moment().startOf('day'), moment()],
      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
      'Last 7 days': [moment().subtract('days', 7), moment()],
      'Last 30 days': [moment().subtract('days', 30), moment()],
      'This month': [moment().startOf('month'), moment().endOf('month')],
      'All days':[moment().subtract('year',5),moment()]
    };
    vmapl.bulkAction = function(param) {
      if(param != 'default' && vmapl.checkedPostsEdit.length>0 ) {
        var putFunction = function() { 
          putDataService.update({
            param1:state, 
            param2: 'bulk',
            param3:'delete'
          },{
            'delete_ids':vmapl.checkedPostsEdit,
          }).$promise.then(function(bulkDelete){
            watchAllCheckboxesNgTable.resetCheckBox(vmapl)
            vmapl.selectedBulkAction = {value: 'default'}; 
            alertService('success','Success ', bulkDelete.message, 2000);
            vmapl.tableParams.reload();
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    putFunction();
                  }
                },
                function(error) {
                  // report something
                },
                function(progress) {
                 // report progress
              });
            }else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            } 
            watchAllCheckboxesNgTable.resetCheckBox(vmapl)
            vmapl.selectedBulkAction = {value: 'default'}; 
          });
        }
        putFunction();
      }
    }
    watchAllCheckboxesNgTable.watch($scope, vmapl)
    vmapl.checkedPost = function(categoryId, checked) {
      if(checked) {
        vmapl.checkedPostsEdit.push(categoryId);
      } else {

        if(vmapl.checkedPostsEdit.includes(categoryId)) {
          var id_tag = categoryId;
          var position = vmapl.checkedPostsEdit.indexOf(id_tag);
          vmapl.checkedPostsEdit.splice(position, 1);
        }
      }
    }
    vmapl.editTitle = function(index) {
      vmapl.selectedTitle = index;
    }
    vmapl.cancelEditTitle = function() {
      vmapl.selectedTitle = -1;
    }
    vmapl.editPoll = function(pollId) {
      
      vmapl.editPollShow = true;
      jQuery("html, body").animate({
        scrollTop: 0
      }, 600);
      vmapl.pollId = pollId;
      $state.transitionTo('app.allpolls', {id: vmapl.pollId}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    vmapl.updateStatus = function(item,status) {
      $rootScope.hasLoaded = false;
        var updateData = {
          'title': item.title,
          'content': item.content,
          'status': status,
          'data':item.data.answers,
          'multiple': item.multiple,
          'max_choices': item.max_choices,
          "image": item.image,
          "expire_date": (status == 'finish')? $filter('date')(new Date().toISOString(), "MMM d, y HH:mm"): null,
          "ads": item.ads
        }
      var putFunction = function() {
        putDataService.update({
          param1:'polls', 
          param2:item._id
        },updateData).$promise.then(function(putPoll){
            $rootScope.hasLoaded = true;
            vmapl.tableParams.reload();
            alertService('success','Success ', putPoll.message, 2000);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  putFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          }else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;  
        });
      }
      putFunction();
    }
    vmapl.deletePoll = function(pollId) {
      var deleteFunction = function() {
        deleteDataService.remove({
          param1:'polls', 
          param2: pollId
        }).$promise.then(function(deletePoll){ 
          alertService('success','Success ', deletePoll.message, 2000);
          vmapl.tableParams.reload();
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  deleteFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }  
        });
      }
      deleteFunction();
    }
    vmapl.changeSearch = function(search_data) {
      if(search_data) {
        s = search_data;
      } else {
        s = null;
        $timeout(function() {
          vmapl.search();
        },0)            
      }
    }
    vmapl.changeDate = function(value) {
      vmapl.dateRangevalue= value;
      if(vmapl.dateRangevalue) {
        if(value.startDate && value.endDate) {
          date_start = value.startDate.format('YYYY-MM-DD');
          date_end = value.endDate.format('YYYY-MM-DD');
        } else {
          date_start = null;
          date_end = null;
        }
      } else {
          date_start = null;
          date_end = null;
      }
    }
    vmapl.changeStatus =function(event,activeStatus) {
      vmapl.status = activeStatus;
      if(activeStatus == 'all') {
        status = null;
      } else {
        status = activeStatus;
      }
      reloadTableFunction();
    }
    function reloadTableFunction() {
      if(vmapl.tableParams.page() ==1) {
        vmapl.tableParams.reload();
      } else {
        vmapl.tableParams.page(1);
      }
    } 
    vmapl.postFilter = function() {
      reloadTableFunction()
    }
    vmapl.resetAllFilters = function() {
      vmapl.searchData = null;
      s =null;
      status = 'publish'
      date_start = null;
      date_end = null;
      $scope.$broadcast('clear-daterange',true);
      reloadTableFunction();
    }
    // vmapl.changeStatus =function(event,activeStatus) {
    //   s=null;
    //   date_start = null;
    //   date_end= null;
    //   reloadTableFunction
    // }
     vmapl.search =function(value) {
      if(value) { 
        s = value.toLowerCase();
      } else {
        s = null;
      }
      reloadTableFunction();
    }
    vmapl.tableReloadFunction = function(page) { 
      vmapl.tableParams = new NgTableParams({
          page: page || 1,
          count: 20,
          
      }, {
        getData: function(params) {
          $rootScope.emptyTable = false;
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: null,   
            s:s,
            status: status,
            sortby: $rootScope.sortby,
            sort : $rootScope.sort,
            date_start: date_start,
            date_end: date_end,
            page: params.page(),
            limit: params.count(),
            }).$promise.then(function(data){
            
            $rootScope.hasLoaded = true;
            $data = data.polls;
            vmapl.dataGet = data.polls; 
            if(data.polls.length == 0) {
              $rootScope.emptyTable = true;
            } else {
              $rootScope.emptyTable = false;
            }
            watchAllCheckboxesNgTable.resetCheckBox(vmapl) 
            params.total(data.count);
            params.numPages(data.max_pages);
            jQuery('.goTo input').val("");
            return $data;
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError('refresh')
              $rootScope.hasLoaded = true;
              return
            }
            if(error.status ==401) {
              
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                 
                  if(answer==200) {
                    vmapl.tableReloadFunction(params.page());
                  }
                  // do something
                },
                function(error) {
                  // report something
                },
                function(progress) {
                 // report progress
                });
            } else if(error.status ==404) {
              $rootScope.emptyTable = true;
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }
            $rootScope.hasLoaded = true;
          });
        }    
      });
    }
    vmapl.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/pollsModule/allpolls/js/allpollsController.js
// module id = 540
// module chunks = 0